module.exports = __webpack_public_path__ + "media/אמא.2bb663d9.mp3";